import { ComponentProps } from 'react';
import clsx from 'clsx';

import { OpSlider } from 'new-components/DLS/OpSlider/OpSlider';
import { OpSkeleton } from 'new-components/DLS/OpSkeleton/OpSkeleton';

import { useOpFormContext } from '../../OpFormContext';
import { OpForm } from '../../OpForm';

import './OpFormSlider.scss';

interface OpFormSliderProps
  extends Pick<
      ComponentProps<typeof OpForm.Item>,
      | 'name'
      | 'label'
      | 'tooltip'
      | 'normalize'
      | 'getValueProps'
      | 'initialValue'
    >,
    Omit<ComponentProps<typeof OpSlider>, 'name' | 'tooltip'> {
  formItemClassName?: string;
  isLoading?: boolean;
  sliderTooltip?: ComponentProps<typeof OpSlider>['tooltip'];
}

export const OpFormSlider = ({
  // Form Item props
  formItemClassName,
  name,
  label,
  tooltip,
  normalize,
  getValueProps,
  initialValue,

  // For skeleton loading state
  isLoading,

  disabled,
  sliderTooltip,
  ...elementProps
}: OpFormSliderProps) => {
  /** The Form is wrapped in a provider that passes the loading context
   *  to the component */
  const { isDataLoading, isReadOnly } = useOpFormContext();

  return (
    <OpForm.Item
      className={clsx('op-form-slider', formItemClassName)}
      name={name}
      tooltip={tooltip}
      label={label}
      normalize={normalize}
      getValueProps={getValueProps}
      initialValue={initialValue}
    >
      {isDataLoading || isLoading ? (
        <OpSkeleton.Avatar active size="small" shape="square" />
      ) : (
        <OpSlider
          disabled={isReadOnly || disabled}
          tooltip={sliderTooltip}
          {...elementProps}
        />
      )}
    </OpForm.Item>
  );
};
